import { auth } from './auth/auth.module';
import { dashboard } from './dashboard/dashboard.module';
import { homeBanner } from './home-banner/home-banner.module';
import { transportationAlternative } from './transportation-alternative/transportation-alternative.module';
import { planningResources } from './planning-resources/planning-resources.module';
import { aboutUs } from './about-us/about-us.module';
import { termsAndCondition } from './terms-and-condition/terms-and-condition.module';
import { privacyPolicy } from './privacy-policy/privacy-policy.module';
import { donation } from './donation/donation.module';
import { contactInfo } from './contact-info/contact-info.module';
import { serviceAreaList } from './service-area/service-area.module';
import { socialLinks } from './social-links/social-links.module';
import { socialShare } from './social-share/social-share.module';
import { tripPlanning } from './trip-planning/trip-planning.module';
import { rhnscnyLogo } from './rhnscny-logo/rhnscny-logo.module';
import { paymentMethods } from './payment-methods/payment-methods.module';
import { dynamicMenus } from './dynamic-menus/dynamic-menus.module';
import { editorTemplate } from './editor-template/editor-template.module';
import { editorTemplateOverview } from './editor-template-overview/editor-template-overview.module';
import { menuList } from './menu-list/menu-list.module';
import { menuSequence } from './menu-sequence/menu-sequence.module';
import { reportList } from './report-list/report-list.module';
import { reportView } from './report-view/report-view.module';
import { pagePublish } from './page-publish/page-publish.module';
import { reportEdit } from './report-edit/report-edit.module';
import { reportAdd } from './report-add/report-add.module';

export const components = angular
	.module('components', [
		auth,
		dashboard,
		homeBanner,
		transportationAlternative,
		planningResources,
		aboutUs,
		termsAndCondition,
		privacyPolicy,
		donation,
		contactInfo,
		serviceAreaList,
		socialLinks,
		socialShare,
		tripPlanning,
		rhnscnyLogo,
		paymentMethods,
		dynamicMenus,
		editorTemplate,
		editorTemplateOverview,
		menuList,
		menuSequence,
		reportList,
		reportView,
		pagePublish,
		reportEdit,
		reportAdd
	])
	.name;


// WEBPACK FOOTER //
// ./src/app/components/components.module.js